import AdminEleven from "@/layouts/AdminEleven.vue";

export const eventsRoutes = [
  {
    path: "/eventos",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "events",
        path: "/gerenciar",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/events/Events.vue"),
        meta: {
          title: "Eventos",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
      {
        name: "newEventsSettings",
        path: "/gerenciar/cadastrar",
        component: () => import("@/views/events/newEvent/EventSettings.vue"),
        meta: {
          title: "Eventos/Gerenciar",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
      {
        name: "newEventsSettingsEdit",
        path: "/gerenciar/editar-evento",
        component: () => import("@/views/events/newEvent/EventSettings.vue"),
        meta: {
          title: "Eventos/Gerenciar",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
      {
        name: "doubleEventSetting",
        path: "/gerenciar/duplicar-evento",
        component: () => import("@/views/events/newEvent/EventSettings.vue"),
        meta: {
          title: "Eventos/Gerenciar",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
      {
        name: "eventsSettings",
        path: "/gerenciar/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/events/EventSettings.vue"
          ),
        meta: {
          title: "Eventos/Gerenciar",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
      {
        name: "order",
        path: "/ordernar",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/events/OrderEvents.vue"
          ),
        meta: {
          title: "Produtos/ordenar",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "categories",
        path: "/categorias",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/events/Categories.vue"
          ),
        meta: {
          title: "Categorias",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "combos",
        path: "/combos",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/events/Combos.vue"),
        meta: {
          title: "Combos",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "comboSettings",
        path: "/combos/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/produtos/combos/comboSettings.vue"
          ),
        meta: {
          title: "Combos/Gerenciar",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
